export enum MeteringPointTabType {
    Details = 'Details',
    Metering = 'Metering',
    FunctionalControl = 'FunctionalControl'
  }